export default __webpack_public_path__ + "static/media/affiche.aac08fba.jpg";